import { PORTAL_IMAGE } from "constants/imagePath";

export const IMPROVE_DESTINATIONS = {
    MEALS: "meals",
    ACTIVITY: "activity_planner",
    PROGRAMS: {
        HEALTHY_HEART: "healthy-heart",
        SLEEP: "better-sleep",
        STRESS: "building-stress-resilience",
        WEIGHT_LOSS: "sustainable-weight-loss",
        PERSONAL_PRODUCTIVITY: "personal-productivity",
        SEVEN_MIN_WORKOUT: "the-7-minute-workout"
    }
};

export const USES_LEARN_WORLD = {
    meals: false,
    // eslint-disable-next-line camelcase
    activity_planner: false,
    "healthy-heart": "heartHealth",
    "better-sleep": "sleep",
    "building-stress-resilience": "buildingStressResilience",
    "sustainable-weight-loss": "sustainableWeightLoss",
    "the-7-minute-workout": "sevenMinuteWorkout"
};

export const PLAN_SEVEN_MIN_WORKOUT = {
    title: "The 7-Minute Workout",
    text: "A 7-minute HIIT exercise session that requires no fitness equipment and can be done at home.",
    image: `${PORTAL_IMAGE}/improve/seven-minute-workout.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.SEVEN_MIN_WORKOUT,
    isPremOnlyCard: true
};

export const PLAN_HEALTHY_HEART = {
    title: "Healthy Heart",
    text: "A 1.5h program to get you started on improving your heart age.",
    image: `${PORTAL_IMAGE}/improve/heart_age.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.HEALTHY_HEART,
    isPremOnlyCard: true
};

export const PLAN_SUSTAINABLE_WEIGHT_LOSS = {
    title: "Sustainable Weight Loss",
    text: "Simple skills for managing your weight & overcoming weight loss challenges.",
    image: `${PORTAL_IMAGE}/improve/sustainable-weight.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.WEIGHT_LOSS,
    isPremOnlyCard: true
};

export const PLAN_BETTER_SLEEP = {
    title: "Better Sleep",
    text: "Understand and improve sleep’s role in your mental health and physical health.",
    image: `${PORTAL_IMAGE}/improve/sleep.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.SLEEP,
    isPremOnlyCard: true
};

export const PLAN_BUILDING_STRESS_RESILIENCE = {
    title: "Building Stress Resilience",
    text: "Simple skills for managing stress and building resilience.",
    image: `${PORTAL_IMAGE}/improve/stress.svg`,
    link: IMPROVE_DESTINATIONS.PROGRAMS.STRESS,
    isPremOnlyCard: true
};

export const IMPROVE_DATA = [
    {
        title: "Activity Planner",
        text: "A dynamic activity planner you can set to your activity preferences.",
        image: `${PORTAL_IMAGE}/improve/activity.svg`,
        link: IMPROVE_DESTINATIONS.ACTIVITY
    },
    {
        title: "Meal Planner",
        text: "Create your weekly personalised meal plan with recipes and a shopping list!",
        image: `${PORTAL_IMAGE}/improve/meal.svg`,
        link: IMPROVE_DESTINATIONS.MEALS
    },
    PLAN_SEVEN_MIN_WORKOUT,
    PLAN_HEALTHY_HEART,
    PLAN_BETTER_SLEEP,
    PLAN_SUSTAINABLE_WEIGHT_LOSS,
    PLAN_BUILDING_STRESS_RESILIENCE
];
